import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { SIDENAV_DATA, SIDENAV_REF, SidenavRef } from '@app/shared/modules/template/components/sidenav';
import { BehaviorSubject } from 'rxjs';

@Component({
  templateUrl: './sidenav-learning-annex.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SidenavLearningAnnexComponent implements OnInit {
  public anexos$ = new BehaviorSubject<any[]>(undefined);

  constructor(@Inject(SIDENAV_REF) private sidenavRef: SidenavRef, @Inject(SIDENAV_DATA) public data: any) {}

  public ngOnInit(): void {
    this.anexos$.next(this.data.anexos);
  }

  public onOpenAnnex(annex: string): void {
    window.open(annex, '_blank');
  }

  public onClose() {
    this.sidenavRef.close();
  }
}
